/* src/app/shared/navbar/navbar.component.less */
.navbar .notification {
  background: #99d11c;
  position: absolute;
  border: 2px solid #fff;
  right: 10px;
  font-size: 5px;
  color: #ffffff;
  min-width: 11px;
  padding: 6px 5px;
  height: 11px;
  border-radius: 10px;
  text-align: center;
  line-height: 19px;
  display: block;
  margin-top: 5px;
}
.iconTheme {
  width: 20px;
  height: 23px;
  color: #AAAAAA;
}
.badge {
  background: #99d11c;
  border: 2px solid #fff;
  height: 50px;
  border-radius: 50px;
  width: 50px;
  display: block;
  padding-right: 5px;
}
label {
  margin-bottom: 0rem;
}
.navbar .collapse .navbar-nav .nav-item .nav-link:not(.btn) .material-icons {
  margin-top: -3px;
  top: 3px;
  position: relative;
  margin-right: 3px;
}
/*# sourceMappingURL=navbar.component.css.map */
